import { eur, fill } from '../lib/license';
import { vatSplit } from '../lib/vat';

export default function VatRows({ t, net, span, testid }) {
  const v = vatSplit(net);
  return (
    <>
      <tr className="vat-row"><td colSpan={span}>{t.vatNet}</td><td data-testid={`${testid}-net`}>{eur(v.net, t.locale)}</td></tr>
      <tr className="vat-row"><td colSpan={span}>{fill(t.vatLine, { rate: v.rate.toLocaleString(t.locale) })}</td><td data-testid={`${testid}-vat`}>{eur(v.vat, t.locale)}</td></tr>
      <tr className="vat-gross"><td colSpan={span}>{t.vatGross}</td><td data-testid={`${testid}-gross`}>{eur(v.gross, t.locale)}</td></tr>
    </>
  );
}
